module.exports = __webpack_public_path__ + "img/luxliebe.afcf47a5.svg";